import { axiosBaseQuery } from '@app/api/make-request'
import { ApiKeys } from '@app/constants/api-keys'
import { createApi } from '@reduxjs/toolkit/query/react'
import { IRtkResponse } from '../../types'
import {
  ICreateBillingPaymentBody,
  ICreatePupilPaymentResponse,
  IGetPupilBillingsResponse,
  IGetPupilPaymentsParams,
  IGetPupilPaymentsResponse,
  IPupilPaymentBillingItem,
  IPupilPaymentItem,
} from '@app/interfaces/kms-billing'

export const pupilBillingApi = createApi({
  baseQuery: axiosBaseQuery(),
  reducerPath: 'pupilBillingApi',
  tagTypes: [ApiKeys.pupilBilling],
  endpoints: (build) => ({
    getPupilBilling: build.query<
      IRtkResponse<IPupilPaymentBillingItem>,
      number
    >({
      query: (pupilId) => ({
        url: `kms-billing/api/v1/pupil-billing`,
        method: 'get',
        params: { pupilId },
      }),
      transformResponse: (response: IGetPupilBillingsResponse, meta) => {
        const _data = response.data?.content?.[0]
        return { response: _data!, meta }
      },
      providesTags: (result, error, arg) => [
        { type: ApiKeys.pupilBilling, id: 'PUPIL_BILLING_DATA' },
      ],
    }),
    createPupilManualPayment: build.mutation<
      ICreatePupilPaymentResponse,
      ICreateBillingPaymentBody
    >({
      query: (data) => ({
        method: 'POST',
        url: 'kms-billing/api/v1/payments/kindergartens/manual',
        data,
        suppressNotification: true,
      }),
      invalidatesTags: (result, error, arg) => [
        { type: ApiKeys.pupilBilling, id: 'PUPIL_PAYMENTS' },
        { type: ApiKeys.pupilBilling, id: 'PUPIL_BILLING_DATA' },
      ],
    }),
    getPupilPaymentHistory: build.query<
      IPupilPaymentItem[],
      IGetPupilPaymentsParams
    >({
      query: (params) => ({
        url: `kms-billing/api/v1/payments`,
        method: 'GET',
        params,
      }),
      transformResponse: (response: IGetPupilPaymentsResponse) => {
        return response.data?.content ?? []
      },
      providesTags: (result, error, arg) => [
        { type: ApiKeys.pupilBilling, id: 'PUPIL_PAYMENTS' },
      ],
    }),
  }),
})

const useStateGetBillingTariffs =
  pupilBillingApi.endpoints.getPupilBilling.useQueryState

export const {
  useCreatePupilManualPaymentMutation,
  useGetPupilBillingQuery,
  useGetPupilPaymentHistoryQuery,
} = pupilBillingApi

export { useStateGetBillingTariffs }
